import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import BasketAddCoupon from '@/ui/views/checkout/BasketAddCoupon.vue';
import BasketRemoveCoupon from '@/ui/views/checkout/BasketRemoveCoupon.vue';
import BasketViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Consumer.BasketViewModel;
import AccordionItem from '@/ui/shared/accordion/AccordionItem.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketCoupon',
  setup(__props) {

const basket = computed<BasketViewModel>(() => store.getters['basket/basket']);
const isBasketLocked = computed<boolean>(() => store.getters['basket/isBasketLocked']);
const isCouponSubmitted = computed<boolean>(() => store.getters['basket/isCouponSubmitted']);

function addCoupon(code: string) {
    store.dispatch('basket/addCoupon', code);
}
function removeCoupon(code: string) {
    store.dispatch('basket/removeCoupon', code);
}

const hasNoCouponCode = computed<boolean>(() => {
    return !basket.value.couponCode;
});

const canAddCoupon = computed<boolean>(() => {
    return !isBasketLocked.value;
});

return { __sfc: true,basket, isBasketLocked, isCouponSubmitted, addCoupon, removeCoupon, hasNoCouponCode, canAddCoupon, BasketAddCoupon, BasketRemoveCoupon, AccordionItem }
}

})